store.admin.dropdownValues = (typeof store.admin.dropdownValues != 'undefined') ? store.admin.dropdownValues : {};

store.admin.dropdownValues.init = function(selector, text, url) {
	var opts = {};
	if (arguments.length == 4) {
		opts = arguments[3];
	}
	$(selector).each(function(){
		var $t = $(this);
		if (!this.disabled) {
			var nodeId = this.id;
			var idNum = parseInt(nodeId.replace(/^.*-/, ''));
			var aUrl = url;
			if (idNum > 0) {
				aUrl += "/" + idNum;
			}
			$t.addClass('dvAdd');
			$('<a class="dvAdd" href="'+aUrl+'" title="'+text+'"><span>'+text+'</span></a>')
				.data('dvOpts', opts)
				.click(store.admin.dropdownValues.add)
				.appendTo($t.parent());
		}
	});
};
store.admin.dropdownValues.dialogId = 'dvAddDialog';
store.admin.dropdownValues.add = function(e) {
	var url = this.href;
	var $this = $(this);

	var dialog = $('<div id="'+store.admin.dropdownValues.dialogId +
		'" style="display:none" class="loading"></div>').appendTo($(this));

	var relId = $this.prev().get(0).id;
	dialog.data('dropdownId', relId);

	var dvOpts = $this.data('dvOpts');
	if (!dvOpts) dvOpts = {};
	var opts = {
		modal: true,
		width:500,
		position: {
			my: 'center',
			at: 'top+150px'
		},
		title: this.title,
		close: function(/*e, ui*/) {
			dialog.remove();
		}
	};
	var o;
	for (o in dvOpts) {
		//noinspection JSUnfilteredForInLoop
		opts[o] = dvOpts[o];
	}
	dialog.dialog(opts);
	$.ajax({
		url: url,
		data: { 'dvAdd': 'true'},
		success: function (data) {
			dialog.html(data);
			dialog.removeClass('loading');
		},
		dataType: "html",
		complete: function(jqXHR, textStatus) {
			if (textStatus == "success") {
				var sel = '#'+store.admin.dropdownValues.dialogId;
				var el = $(sel);
				store.admin.initLang(sel);
				store.admin.switchLang(el.find("ul.langPicker li:first").attr('rel'), sel);
				el.find('.eType_codename').each(function(){
					var cName = this.id.replace('elm_', '');
					var cVal = $(this).find('#'+cName+'_placeholder').attr('codenameaction');
					if (!cVal) cVal = cName;
					store.admin.codename.init(cName, cVal);
				});
				el.find(".cancel").attr('onclick', '').click(function(){
					el.dialog('close');
					return false;
				});
				el.find('form').submit(function(){
					var data = $(this).serialize();
					$.post(this.action, data, function(data/*, textStatus*/) {
						var isJson = (data.length > 0 && store.admin.trim(data)[0] == '{');
						if (!isJson) {
							dialog.html(data);
						}
						else {
							store.admin.dropdownValues.update(el.data('dropdownId'), data);
							el.dialog('close');
						}
					});
					return false;
				});
				el.find("input:first").focus();
			}
		}
	});
	e.preventDefault();
	return false;
};
store.admin.dropdownValues.update = function(dropdownId, str) {
	var data = JSON.parse(str);
	//noinspection JSUnresolvedVariable
	var o = $("<option>", {
		value: data.value,
		label: data.label
	}).text(data.value);

	//noinspection JSUnresolvedVariable
	$('#'+dropdownId)
		.append(o)
		.val(data.value)
		.trigger('change');
};
